import React from 'react';
import AddItemButton from 'sushiweb/Order/AddItemButton';

export const AddItem = ({
  handleIncrease,
  handleDecrease,
  disabled,
  count,
  increaseDisabled = false,
  decreaseDisabled = false,
}) => {
  return (
    <AddItemButton
      itemCount={count}
      fnOnCountIncrease={handleIncrease}
      fnOnCountDecrease={handleDecrease}
      disabled={disabled}
      decreaseDisabled={decreaseDisabled}
      increaseDisabled={increaseDisabled}
    />
  );
};
